export default interface ServiceType {
  ServiceTypeID: number
  ServiceTypeName: string
  ServiceTypeCode: string
  DisplayOrder: number
}

export enum ServiceTypeCode {
  Drug = "Drug",
  Alcohol = "Alcohol",
  Physical = "Physical",
  OHS = "OHS",
  POCT = "POCT",
  Background = "Background",
  Audiogram = "Audiogram",
  CHS = "CHS",
  None = ""
}


let emptyServiceType = {
  ServiceTypeID: 0,
  ServiceTypeName: "",
  ServiceTypeCode: "",
  DisplayOrder: 0
}
export function ServiceTypeById(items: ServiceType[], serviceTypeId: number): ServiceType {
  for (let i = 0; i < items.length; i++) {
    if (items[i].ServiceTypeID === serviceTypeId) {
      return items[i];
    }
  }
  return emptyServiceType;
}

export function ServiceTypeByCode(items: ServiceType[], code: ServiceTypeCode): ServiceType {
  for (let i = 0; i < items.length; i++) {
    if (items[i].ServiceTypeCode === code) {
      return items[i];
    }
  }
  
  return emptyServiceType;
}


export function GetDrugServiceType(items: ServiceType[]): ServiceType {
  return ServiceTypeByCode(items, ServiceTypeCode.Drug);
}

export function GetAlcoholServiceType(items: ServiceType[]): ServiceType  {
  return ServiceTypeByCode(items, ServiceTypeCode.Alcohol);
}

export function GetPhysicalServiceType(items: ServiceType[]): ServiceType  {
  return ServiceTypeByCode(items, ServiceTypeCode.Physical);
}

export function GetOHSServiceType(items: ServiceType[]): ServiceType  {
  return ServiceTypeByCode(items, ServiceTypeCode.OHS);
}

export function GettPOCTServiceType(items: ServiceType[]): ServiceType  {
  return ServiceTypeByCode(items, ServiceTypeCode.POCT);
}

export function GettBackgroundServiceType(items: ServiceType[]): ServiceType {
  return ServiceTypeByCode(items, ServiceTypeCode.Background);
}
export function GetCHSServiceType(items: ServiceType[]): ServiceType  {
  return ServiceTypeByCode(items, ServiceTypeCode.CHS);
}

export function IsServiceTypeDrug(data: ServiceType): boolean {
  if (data.ServiceTypeCode === ServiceTypeCode.Drug) {
    return true;
  }
  return false;
}
export function IsServiceTypeAlcohol(data: ServiceType): boolean {
  if (data.ServiceTypeCode === ServiceTypeCode.Alcohol) {
    return true;
  }
  return false;
}

export function IsServiceTypePhysical(data: ServiceType): boolean {
  if (data.ServiceTypeCode === ServiceTypeCode.Physical) {
    return true;
  }
  return false;
}

export function IsServiceTypeOHS(data: ServiceType): boolean {
  if (data.ServiceTypeCode === ServiceTypeCode.OHS) {
    return true;
  }
  return false;
}


export function IsServiceTypePOCT(data: ServiceType): boolean {
  if (data.ServiceTypeCode === ServiceTypeCode.POCT) {
    return true;
  }
  return false;
}


export function IsServiceTypeBackground(data: ServiceType): boolean {
  if (data.ServiceTypeCode === ServiceTypeCode.Background) {
    return true;
  }
  return false;
}

export function IsServiceTypeCHS(data: ServiceType): boolean {
  return data.ServiceTypeCode === ServiceTypeCode.CHS
}

export function IsServiceTypeCodeDrug(code: ServiceTypeCode): boolean {
  if (code === ServiceTypeCode.Drug) {
    return true;
  }
  return false;
}
export function IsServiceTypeCodeAlcohol(code: ServiceTypeCode): boolean {
  if (code === ServiceTypeCode.Alcohol) {
    return true;
  }
  return false;
}

export function IsServiceTypeCodePhysical(code: ServiceTypeCode): boolean {
  if (code === ServiceTypeCode.Physical) {
    return true;
  }
  return false;
}

export function IsServiceTypeCodeOHS(code: ServiceTypeCode): boolean {
  if (code === ServiceTypeCode.OHS) {
    return true;
  }
  return false;
}


export function IsServiceTypeCodePOCT(code: ServiceTypeCode): boolean {
  if (code === ServiceTypeCode.POCT) {
    return true;
  }
  return false;
}


export function IsServiceTypeCodeBackground(code: ServiceTypeCode): boolean {
  if (code === ServiceTypeCode.Background) {
    return true;
  }
  return false;
}

export function IsServiceTypeCodeCHS(code: ServiceTypeCode): boolean {
  return code === ServiceTypeCode.CHS
}